import 'babel-polyfill'            // ES6转义的一些API
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import MintUI from 'mint-ui'       // 导入mint-ui 组件和样式
import fastclick from 'fastclick'
import 'mint-ui/lib/style.css'
import 'common/js/rem'
import common from 'common/js/common'
import store from './store'
Vue.use(MintUI)
Vue.prototype.$http = axios        // 把aixos加入原型链
Vue.prototype.common = common      // 把common.js加入原型链
fastclick.attach(document.body)    // 阻止手机端点击300毫秒延迟
Vue.config.productionTip = false
Vue.filter('capitalize', common.formatDate2)
window.eventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js